<template>
  <div class="pa-4" style="position: relative;">

    <policy-wizard
      ref="policyWizardDialog"
      :household="household"
      @on-save="updateSavedPolicy"
      use-url
    />

    <policy-sheet
      ref="policySheet"
      :household="household"
      @on-save="updateSavedPolicy"
      @on-plans-altered="$emit('on-plans-altered')"
    />
    
    <v-row class="justify-center">
      <v-col
        v-for="policy in policiesSorted"
        :key="'policy' + policy.id"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <policy-card
          :policy="policy"
          @on-delete="$emit('on-policy-deleted', policy)"
          @on-click="$router.push({params:{policy_action:'edit',policy_id:policy.id}})"
        />
      </v-col>
    </v-row>
    <v-row class="justify-center">
      <v-col cols="3">
        <policy-card 
          :policy="{}" 
          @on-click="$router.push({params:{policy_action:'add',policy_id:null}})"
          dense
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PolicyCard from './Card'
import PolicyWizard from './PolicyWizard'
import PolicySheet from './PolicySheet'

export default {
  name: 'HouseholdsPoliciesIndex',
  props: {
    household: {
      type: Object,
      required: true
    }
  },
  components: {
    PolicyCard,
    PolicyWizard,
    PolicySheet
  },
  data () {
    return {
    }
  },
  mounted() {
  },
  watch: {
    $route: {
      handler() {
        
      },
      deep: true
    }
  },
  computed: {
    action () {
      return this.$route.params.policy_action
    },
    addPolicyDialog () {
      return (this.action == 'add' || this.action == 'edit')
    },
    policiesSorted () {
      let p = JSON.parse(JSON.stringify(this.household.policies))
      p.sort((a,b) => (a.active - b.active))
      return p
    }
  },
  methods: {
    updateSavedPolicy (policy) {
      this.$router.replace({params:{policy_action:null,policy_id:null}})
      this.$emit('on-policy-updated', policy)
    },
    deletePolicy (policy) {
      this.$emit('on-policy-deleted', policy)
    },
    policyUser( user_id ) {
      if(this.household.user_id == user_id) return this.household.user
      if(this.household.spouse_id == user_id) return this.household.spouse
    },
    updatePolicy (policy, active) {
      policy.saving = true
      policy.active = active
      this.$emit('on-policy-updated', policy)

      let data = {
        active: (active ? 1 : 0)
      }
      this.$http.put('policies/' + policy.id, data)
        .then(response => {
          this.$emit('on-policy-updated', response.data)
        })
        .catch(() => {
          policy.saving = false
          policy.active = !active
          this.$emit('on-policy-updated', policy)
          this.$swal.fire('Error', 'There was an error updated policy #' + policy.id + '\'s status', 'error')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .policyName {
    font-size: 16px;
  }
  .dragIcon {
    cursor: move;
  }

</style>

<style lang="scss">
  .policyActiveSwitch {
    .v-progress-circular {
      >svg {
        position: unset;
      }
    }
  }
</style>